// import { memo, useEffect, useState, useCallback } from "react";
// import {
//     Card,
//     CardContent,
//     TextField,
//     Typography,
//     Grid,
//     Box,
//     Button,
//     IconButton,
//     Divider,
//     FormControl,
//     InputLabel,
//     FormHelperText,
//     Select,
//     MenuItem,
//     Chip,
//     CircularProgress,
//     Tooltip,
//     FormControlLabel,
//     Radio,
//     RadioGroup,
//     Paper,
//     Dialog,
//     DialogContent,
//     DialogTitle,
// } from "@mui/material";
// import { useNavigate, } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { Controller, useForm } from "react-hook-form";
// import { zodResolver } from "@hookform/resolvers/zod";
// import { z } from "zod";
// import { useTMutation } from "../../../../../utils/useTMutation";
// import showToast from "../../../../../components/Hot-Toast/showToast";
// import {
//     emptyValues,
//     previousStep,
//     update,
// } from "../../../../../slice/multiStepSlice";
// import { useQuery } from "@tanstack/react-query";
// import { fetchJobRoles } from "../../../../../utils/commonAPI";
// import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import "react-phone-input-2/lib/style.css";
// import CloseIcon from "@mui/icons-material/Close";
// import { List, ListItem, } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
// import * as React from 'react';
// import PlayArrowIcon from '@mui/icons-material/PlayArrow';
// import { VscCloudUpload } from 'react-icons/vsc';
// import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
// import PdfViewer from "../../../../../components/PDFViewer/pdfViwer";
// import { convertToFormData } from "../../../../../utils/genericMethod";
// import { API_URL } from "../../../../../appConstants";




// export const jobRoleSchema = z.object({
//     trainingCertificateName: z.string().min(1, { message: "Document Name is required" }),
//     requirementType: z.string().min(1, { message: "Requirement is required" }),
//     JOBROLE_ID: z.array(z.string().uuid()).min(1, "At least one Job role must be selected"),
//     status: z.string().min(1, { message: "Status is required" }),
//     noOfReattempt: z
//         .string()
//         .min(1, { message: "No of Attempts is required" }) // Ensures input is not empty
//         .transform((val) => Number(val)) // Convert string to number
//         .refine((val) => val >= 1 && val <= 9, { message: "Attempts must be between 1 and 9" }),

// });


// function validateLessons(lessons) {
//     let errors = [];
//     if (lessons.length <= 0) {
//         errors.push(`Lesson is missing or empty`);
//     }
//     lessons.forEach((lesson, lessonIndex) => {
//         if (!lesson.lessonTitleName) {
//             errors.push(`Lesson ${lessonIndex + 1}: lessonTitleName is missing or empty`);
//         }

//         if (!Array.isArray(lesson.questions) || lesson.questions.length === 0) {
//             errors.push(`Lesson ${lessonIndex + 1}: questions array is missing or empty`);
//         } else {
//             if (lesson.questions.length < lesson.showNoOfQuestion) {
//                 errors.push(`Lesson ${lessonIndex + 1}: questions array has fewer questions (${lesson.questions.length}) than required (${lesson.showNoOfQuestion})`);
//             }

//             lesson.questions.forEach((question, questionIndex) => {
//                 if (!question.question) {
//                     errors.push(`Lesson ${lessonIndex + 1}, Question ${questionIndex + 1}: question is missing or empty`);
//                 }
//                 if (!question.correctAnswer) {
//                     errors.push(`Lesson ${lessonIndex + 1}, Question ${questionIndex + 1}: correctAnswer is missing`);
//                 }
//                 if (!Array.isArray(question.choices) || question.choices.length === 0) {
//                     errors.push(`Lesson ${lessonIndex + 1}, Question ${questionIndex + 1}: choices array is missing or empty`);
//                 } else if (question.choices.length < 2) {
//                     errors.push(`Lesson ${lessonIndex + 1}, Question ${questionIndex + 1}: choices array must have at least 2 options`);
//                 }

//                 question.choices.forEach((choice, choiceIndex) => {
//                     if (!choice.option) {
//                         errors.push(`Lesson ${lessonIndex + 1}, Question ${questionIndex + 1}, Choice ${choiceIndex + 1}: option is missing or empty`);
//                     }
//                 });
//             });
//         }
//     });

//     return errors;
// }


// const LessonList = () => {
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const { values } = useSelector((state) => state?.multiStep); console.log("values", values);
//     const { selectedTabData } = useSelector((state) => state.profileTabSection);
//     const [open, setOpen] = React.useState(false);
//     const handleOpen = () => setOpen(true);
//     const handleClose = () => setOpen(false);
//     const { userDetails } = useSelector(state => state?.user);
//     const initialLessonFormState = { ID: undefined, lessonTitleName: "", lessonVideoDuration: "", lessonObjective: "", lessonVideoUrl: "", showNoOfQuestion: 3, lessonDescription: "", file: null, trainingType: 'Videos' };
//     const initialQuestionFormState = {
//         question: "",
//         choices: [{ option: "", ID: undefined }], // ✅ Correct structure
//         correctAnswer: null
//     };
//     const [trainingLessonsErrors, setTrainingLessonsErrors] = useState([]);

//     const [selectedRoles, setSelectedRoles] = useState([]);
//     //Question related useState
//     const [showQuestionForm, setShowQuestionForm] = useState(false);
//     const [questions, setQuestions] = useState(initialQuestionFormState);
//     const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

//     //Lesson related useState
//     const [lessonErrors, setLessonErrors] = useState({});//use for LessonForm Input errors
//     const [lessonList, setLessonList] = useState([]);
//     const [selectedLessonCard, setSelectedLessonCard] = useState(null);
//     const [showLessonForm, setShowLessonForm] = useState(false);
//     const [lessonFormInput, setLessonFormInput] = useState([initialLessonFormState]);
//     const [isFirstRender, setIsFirstRender] = useState(true);
//     const [fileName, setFileName] = useState(null); // Store uploaded file name
//     const [uploadedFilePath, setUploadedFilePath] = useState('');
//     const [pdfUrl, setPdfUrl] = useState('');
//     const { controlBy, controlAction } = useSelector(state => state.user);
//     console.log("values", values)
//     const validateForm = () => {
//         let newErrors = {};

//         if (lessonFormInput.trainingType === "Videos") {
//             ["lessonTitleName", "lessonVideoDuration", "lessonVideoUrl", "showNoOfQuestion"].forEach((key) => {
//                 if (!lessonFormInput[key]) {
//                     newErrors[key] = "This field is required";
//                 }
//             });
//         } else if (lessonFormInput.trainingType === "Pdf") {
//             ["lessonTitleName", "file", "showNoOfQuestion"].forEach((key) => {
//                 if (!lessonFormInput[key] || lessonFormInput[key] === null) {
//                     newErrors[key] = "This field is required";
//                 }
//             });
//         }

//         setLessonErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };
//     console.log("lessonErrors", lessonErrors)
//     const { data: fetchJobRole = [], isLoading, isError, } = useQuery({
//         queryKey: ["jobRoles"],
//         queryFn: fetchJobRoles,
//         staleTime: 60000 * 2,
//     });
//     const { mutateAsync, isPending } = useTMutation("/addUpdateTrainingLesson", "post", (response) => {
//         showToast(response.STATUS ? "success" : "error", response.MESSAGE)
//         return response;
//     });
//     const saveQuestionMutation = useTMutation('/addUpdateLessonQuestion', 'post', (data) => {
//         showToast(data.STATUS ? "success" : "error", data.MESSAGE, 3000);
//     });
//     const RemoveQuestionMutation = useTMutation('/removeLessonQuestionByID', 'post', (data) => {
//         showToast(data.STATUS ? "success" : "error", data.MESSAGE, 3000);
//     });
//     const removeLessonMutation = useTMutation('/removeLessonByID', 'post', (data) => {
//         showToast(data.STATUS ? "success" : "error", data.MESSAGE, 3000);
//     });
//     const saveTrainingMutation = useTMutation('/addUpdateTrainingCertificates', 'post', (data) => {
//         showToast(data.STATUS ? "success" : "error", data.MESSAGE, 3000);
//     });

//     const {
//         control,
//         register,
//         setValue,
//         clearErrors,
//         trigger,
//         handleSubmit,
//         formState: { errors },
//     } = useForm({
//         resolver: zodResolver(jobRoleSchema),
//         defaultValues: {
//             trainingCertificateName: values?.trainingCertificateName || "",
//             requirementType: values?.requirementType || "",
//             status: values?.status || "Active",
//             noOfReattempt: values?.noOfReattempt?.toString() || "3",
//             JOBROLE_ID: values?.JOBROLE_ID || [],
//         },
//     });
//     useEffect(() => {
//         if (values?.lessonList?.length > 0 && lessonList?.length === 0 && isFirstRender) {
//             // Only set the first lesson when lessonList is initially empty
//             console.log("default set URL", values?.lessonList?.[0]?.file);
//             setPdfUrl(API_URL + "user/viewFile?fileName=" + values?.lessonList?.[0]?.file)
//             // setUploadedFilePath(values?.lessonList?.[0]?.file);
//             setFileName(`${values?.lessonList?.[0]?.lessonTitleName} Document.pdf`)
//             setQuestions(values?.lessonList?.[0]?.questions || []);
//             setLessonList(values.lessonList);
//             setSelectedLessonCard(values?.lessonList[0]);
//             setLessonFormInput(values?.lessonList[0]);
//             setShowLessonForm(true);
//         }
//         setIsFirstRender(false);
//     }, [values?.lessonList]);
//     useEffect(() => {
//         if (values?.JOBROLE_ID?.length > 0) {
//             setSelectedRoles(values?.JOBROLE_ID);
//             setValue('JOBROLE_ID', values?.JOBROLE_ID);
//         }
//     }, [values?.JOBROLE_ID]);
//     //Lesson related function
//     const handleSelect = (lessonId) => {
//         const selectedLesson = lessonList.find((lesson) => lesson.ID === lessonId);
//         setSelectedLessonCard(selectedLesson);
//         console.log("selected card URL", selectedLesson.file);
//         setPdfUrl(API_URL + "user/viewFile?fileName=" + selectedLesson?.file)
//         // setUploadedFilePath(selectedLesson?.file);
//         setFileName(`${selectedLesson?.lessonTitleName} Document.pdf`)
//         if (selectedLesson) {
//             setLessonFormInput({ ...selectedLesson }); // Set form input with selected lesson
//             setShowLessonForm(true); // Show the lesson form
//             setShowQuestionForm(false); // Show the lesson form

//             setQuestions(selectedLesson?.questions || [initialQuestionFormState]);
//             setCurrentQuestionIndex(selectedLesson?.questions?.length || 0);

//         }
//     };

//     const handleSaveLessonFormInput = async (e) => {
//         e.preventDefault();
//         e.stopPropagation();

//         if (!validateForm()) return;
//         const { ID, ...lessonData } = lessonFormInput;
//         const trainingCertificateID = values?.ID;
//         const rawPayload = {
//             trainingCertificateID,
//             ...(ID ? { ID } : {}), // Include only if ID is truthy
//             ...lessonData
//         };
//         const formData = convertToFormData(rawPayload);
//         const response = await mutateAsync(formData);

//         if (response.STATUS) {
//             // ✅ Set uploaded file path if available (PDF only)
//             if (response?.OUTPUT?.trainingType === 'Pdf' && response?.OUTPUT?.file) {
//                 setPdfUrl(API_URL + "user/viewFile?fileName=" + response.OUTPUT?.file)
//                 // setUploadedFilePath(response.OUTPUT.file);
//                 setFileName(`${selectedLessonCard?.lessonTitleName} Document.pdf`)
//             }
//             setLessonList((prevLessons) => {
//                 const updatedLessons = ID
//                     ? prevLessons.map((lesson) => (lesson.ID === ID ? { ...lesson, ...response.OUTPUT } : lesson)) // Update existing
//                     : [...prevLessons, { ...response.OUTPUT, questions: [] }];// Insert new
//                 console.log("updatedLessons", updatedLessons)
//                 dispatch(update({ lessonList: updatedLessons })); // Update Redux state
//                 return updatedLessons;
//             });
//             if (!ID) {
//                 setSelectedLessonCard({ ...response.OUTPUT, questions: [] }); // Set current lesson
//                 setQuestions([initialQuestionFormState]);
//                 setCurrentQuestionIndex(0);
//             }
//             setLessonFormInput(initialLessonFormState);
//             setShowLessonForm(false);
//             setShowQuestionForm(true);
//         }
//     };

//     const handleRemoveLesson = async (lessonID) => {
//         const response = await removeLessonMutation.mutateAsync({ ID: lessonID });
//         if (response.STATUS) {
//             setLessonList((prevLessons) => {
//                 const updatedLessons = prevLessons.filter((lesson) => lesson.ID !== lessonID);
//                 // setLessonFormInput(initialLessonFormState);
//                 setShowQuestionForm(false);
//                 let newSelectedLesson = null;
//                 const removedIndex = prevLessons.findIndex((lesson) => lesson.ID === lessonID);
//                 // If the removed lesson was selected, update selectedLessonCard
//                 if (selectedLessonCard?.ID === lessonID) {
//                     // Try selecting the next lesson (if available), otherwise pick the previous one
//                     if (updatedLessons.length > 0) {
//                         if (removedIndex < updatedLessons.length) {
//                             newSelectedLesson = updatedLessons[removedIndex]; // Select next one
//                         } else {
//                             newSelectedLesson = updatedLessons[updatedLessons.length - 1]; // Fallback to last one
//                         }
//                     }
//                     setSelectedLessonCard(newSelectedLesson);

//                     // Pass ID of the updated selectedLessonCard object
//                     if (newSelectedLesson) {
//                         handleSelect(newSelectedLesson.ID);
//                     } else {
//                         setLessonFormInput(initialLessonFormState);
//                     }
//                 }
//                 return updatedLessons;
//             });
//         }
//     };
//     const handleToggleQuestion = () => {
//         setShowLessonForm(false)
//         setShowQuestionForm((prev) => !prev);
//     };


//     const handleChipDelete = (jobRoleID) => {
//         setSelectedRoles((prev) => prev.filter((id) => id !== jobRoleID));
//         setValue(
//             "JOBROLE_ID",
//             selectedRoles.filter((id) => id !== jobRoleID)
//         );
//         clearErrors("JOBROLE_ID");
//     };
//     const handleRoleChange = (selectedRoleId) => {
//         if (!selectedRoles.includes(selectedRoleId)) {
//             const updatedRoles = [...selectedRoles, selectedRoleId];
//             setSelectedRoles(updatedRoles);
//             setValue("JOBROLE_ID", updatedRoles);
//             trigger("JOBROLE_ID");
//         }
//     };
//     const submitAddDocument = async (data) => {
//         try {
//             const validationErrors = validateLessons(lessonList);
//             setTrainingLessonsErrors(validationErrors)
//             if (validationErrors.length > 0) {
//                 console.log("Validation Errors:", validationErrors);
//                 return;
//             }
//             const response = await saveTrainingMutation.mutateAsync({ ...data, USER_ID: userDetails?.ID, ID: values?.ID });
//             if (response.STATUS) {
//                 dispatch(emptyValues());
//                 navigate("/admin/profile-criteria/LearningDocuments");
//             }
//         } catch (error) {
//             console.error("Add Request failed:", error);
//             showToast("error", "Something went wrong, Please try again", 3000);
//         }
//     };
//     const handleChange = (e) => {
//         setLessonFormInput({ ...lessonFormInput, [e.target.name]: e.target.value });
//     };


//     //MCQ related function
//     const saveQuestionAndOptions = (callback) => {
//         const currentQuestion = questions[currentQuestionIndex];
//         if (!currentQuestion || !currentQuestion.question || currentQuestion.choices.length <= 1 || currentQuestion.correctAnswer === null) {
//             showToast('error', "Please complete the question and select a correct answer.");
//             return;
//         }
//         setLessonList(prevLessons => {
//             const updatedLessons = prevLessons.map(lesson => {
//                 if (lesson.ID !== selectedLessonCard.ID) return lesson;

//                 const updatedQuestions = lesson.questions ? [...lesson.questions] : [];
//                 if (currentQuestionIndex < updatedQuestions.length) {
//                     updatedQuestions[currentQuestionIndex] = questions[currentQuestionIndex];
//                 } else {
//                     updatedQuestions.push(questions[currentQuestionIndex]);
//                 }

//                 return { ...lesson, questions: updatedQuestions };
//             });

//             dispatch(update({ lessonList: updatedLessons }));

//             // Call the callback only if save was successful
//             if (callback) callback();

//             return updatedLessons;
//         });
//     };
//     const handleSaveAndAddNew = () => {
//         // when callback comes after callback add new question runs
//         saveQuestionAndOptions(() => {
//             setQuestions(prevQuestions => [
//                 ...prevQuestions,
//                 { question: "", choices: [{ option: "", ID: undefined }], correctAnswer: null }
//             ]);
//             setCurrentQuestionIndex(prevIndex => prevIndex + 1);
//         });
//     };
//     const handleQuestionBack = () => {
//         saveQuestionAndOptions(() => {
//             setCurrentQuestionIndex((prev) => prev - 1)
//         })
//     }
//     const handleQuestionNext = () => {
//         saveQuestionAndOptions(() => {
//             setCurrentQuestionIndex((prev) => prev + 1)
//         })
//     }
//     const handleQuestionChange = (e) => {
//         console.log("currentQuestionIndex:", currentQuestionIndex, "questions:", questions);


//         if (!questions[currentQuestionIndex]) {
//             setQuestions((prevQuestions) => {
//                 const newQuestions = [...prevQuestions];
//                 newQuestions[currentQuestionIndex] = { question: e.target.value, choices: [{ option: "", ID: undefined }], correctAnswer: null };
//                 return newQuestions;
//             });
//         } else {
//             setQuestions((prevQuestions) =>
//                 prevQuestions.map((q, index) =>
//                     index === currentQuestionIndex ? { ...q, question: e.target.value } : q
//                 )
//             );
//         }
//     };
//     const handleAddChoice = () => {
//         const currentChoices = questions[currentQuestionIndex].choices;

//         if (currentChoices.some(choice => choice.option.trim() === "")) {
//             showToast("error", "Please fill all options before adding a new one.");
//             return;
//         }
//         if (currentChoices.length >= 5) {
//             showToast("error", "You can add up to 5 options only.");
//             return;
//         }

//         setQuestions(prevQuestions => {
//             const updatedQuestions = [...prevQuestions];
//             updatedQuestions[currentQuestionIndex] = {
//                 ...updatedQuestions[currentQuestionIndex],
//                 choices: [...updatedQuestions[currentQuestionIndex].choices, { option: "", ID: undefined }],
//             };
//             return updatedQuestions;
//         });
//     };

//     const handleRemoveQuestion = async (index) => {
//         if (questions.length === 0) {
//             showToast("error", "At least one question is required.");
//             return;
//         }
//         const questionToRemove = questions[index];

//         if (questionToRemove?.ID) {
//             const response = await RemoveQuestionMutation.mutateAsync({ ID: questionToRemove.ID });
//             if (!response.STATUS) return;
//         }
//         const updatedQuestions = questions.filter((_, i) => i !== index);
//         setQuestions(updatedQuestions);
//         setCurrentQuestionIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : 0));
//         setLessonList((prevLessons) => {
//             const updatedLessons = prevLessons.map((lesson) => {
//                 if (lesson.ID === selectedLessonCard.ID) {
//                     return { ...lesson, questions: updatedQuestions };
//                 }
//                 return lesson;
//             });

//             dispatch(update({ lessonList: updatedLessons }));
//             return updatedLessons;
//         });


//     };
//     const handleRemoveChoice = (index) => {
//         setQuestions(prevQuestions => {
//             const updatedQuestions = [...prevQuestions];
//             const currentChoices = updatedQuestions[currentQuestionIndex].choices;
//             if (currentChoices.length <= 1) {
//                 showToast("error", "At least one choice is required.");
//                 return prevQuestions;
//             }

//             const updatedChoices = currentChoices.filter((_, i) => i !== index);
//             let updatedCorrectAnswer = updatedQuestions[currentQuestionIndex].correctAnswer;
//             if (updatedCorrectAnswer === index) {
//                 updatedCorrectAnswer = null;
//             } else if (updatedCorrectAnswer > index) {
//                 updatedCorrectAnswer -= 1;
//             }

//             updatedQuestions[currentQuestionIndex] = {
//                 ...updatedQuestions[currentQuestionIndex],
//                 choices: updatedChoices,
//                 correctAnswer: updatedCorrectAnswer,
//             };

//             return updatedQuestions;
//         });
//     };
//     const handleSaveLessonWithQuestions = async () => {
//         const currentQuestion = questions[currentQuestionIndex];
//         if (!currentQuestion || !currentQuestion.question || currentQuestion.choices.length <= 1 || currentQuestion.correctAnswer === null) {
//             showToast('error', "Please complete the question and select a correct answer.");
//             return;
//         }
//         const updatedLessons = lessonList.map(lesson => {
//             if (lesson.ID === selectedLessonCard.ID) {
//                 const existingQuestions = lesson.questions || [];
//                 const updatedQuestions = [...existingQuestions];
//                 if (currentQuestionIndex < updatedQuestions.length) {
//                     updatedQuestions[currentQuestionIndex] = currentQuestion;
//                 } else {
//                     updatedQuestions.push(currentQuestion);
//                 }
//                 return { ...lesson, questions: updatedQuestions };
//             }
//             return lesson;
//         });
//         const response = await saveQuestionMutation.mutateAsync({
//             trainingCertificateID: values?.ID,
//             lessonID: selectedLessonCard?.ID,
//             questions: updatedLessons.find(lesson => lesson.ID === selectedLessonCard.ID)?.questions || [],
//         });
//         if (response.STATUS) {
//             setLessonList(updatedLessons);
//             dispatch(update({ lessonList: updatedLessons }));
//             setLessonFormInput(initialLessonFormState);
//             setQuestions([initialQuestionFormState]);
//             setCurrentQuestionIndex(0);
//             setShowLessonForm(true);
//             setShowQuestionForm(false);
//         }
//     };



//     // Latest Code 23Apr 2025

//     // const [selectedOption, setSelectedOption] = useState("Videos"); // Default is "Videos"



//     // Handle radio button change
//     const handleRadioChange = (event) => {
//         setLessonFormInput(prevLessonFormInput => ({ ...prevLessonFormInput, trainingType: event.target.value }))
//     };


//     const mutation = useTMutation("/profile", "patch", (data) => {
//         if (data.STATUS) {
//             showToast("success", data.MESSAGE, 3000);
//             return data;
//         } else {
//             showToast("error", data.MESSAGE, 3000);
//         }
//     });

//     // const onSubmit = async (data) => {
//     //     // return console.log("PAYLOAD: ", { ...data, USER_ID: selectedTabData?.about?.USER_ID, JOBROLE_ID: selectedTabData?.about?.JOBROLE_ID, licenseID });

//     //     try {
//     //         const formData = new FormData();

//     //         formData.append('file', data.file); // File can be appended directly            
//     //         formData.append('USER_ID', selectedTabData?.about?.USER_ID);


//     //         const response = await mutation.mutateAsync(formData);
//     //         if (response.STATUS) {
//     //             navigate(-1);
//     //         }
//     //     } catch (error) {
//     //         console.log("Request saved details error", error.message);
//     //     }
//     // };





//     const handleFileValidation = useCallback(
//         (file) => {
//             if (!file || file.size > 5 * 1024 * 1024) return false;

//             const allowedTypes = ['application/pdf',];
//             if (!allowedTypes.includes(file.type)) return false;

//             setLessonErrors(prevErrors => {
//                 const { file, ...rest } = prevErrors;
//                 return rest;
//             });

//             return true;
//         },
//         []
//     );

//     const handleDrop = useCallback(
//         (event) => {
//             event.preventDefault();
//             const file = event.dataTransfer.files[0];
//             setValue("file", file, { shouldValidate: true });
//             if (handleFileValidation(file)) {
//                 setFileName(file.name);
//                 setUploadedFilePath(URL.createObjectURL(file));
//             } else {
//                 setLessonErrors({ 'file': 'File size exceeds 5MB' });
//             }
//         },
//         [handleFileValidation, setValue]
//     );

//     //   const handleClose = () => setOpen(false);

//     // const onSubmit = async (data) => {
//     //     try {
//     //         const formData = new FormData();
//     //         formData.append('file', data.file);
//     //         formData.append('USER_ID', selectedTabData?.about?.USER_ID);

//     //         const response = await mutation.mutateAsync(formData);

//     //         if (response.STATUS) {
//     //             navigate(-1);
//     //         }
//     //     } catch (error) {
//     //         console.log("Request saved details error", error.message);
//     //     }
//     // };

//     return (
//         <Grid
//             container
//             spacing={2}
//             direction="row"
//             justifyContent="space-between"
//             alignItems="flex-start">
//             {!values.REDIRECT && (
//                 <Button
//                     onClick={() => dispatch(previousStep())}
//                     startIcon={
//                         <ArrowBackIosIcon sx={{ fontSize: "12px", color: "#000000" }} />
//                     }
//                     sx={{
//                         textTransform: "none",
//                         fontWeight: 500,
//                         fontSize: "14px",
//                         padding: 3,
//                         minWidth: 0,
//                         marginTop: -1,
//                     }}></Button>
//             )}
//             <Grid item xs={12} mt={-2}>

//                 <Grid container spacing={2} direction="row">
//                     {/* Lesson List Section */}
//                     <Grid item xs={12} sm={3}>
//                         <Box >
//                             <Card sx={{
//                                 p: 2, borderRadius: 0, boxShadow: 3,
//                                 height: "80vh",
//                                 overflow: "auto"
//                             }}
//                             >
//                                 <Box px={3} display="flex" justifyContent="space-between" alignItems="center">
//                                     <Typography variant="h4" sx={{ fontWeight: "bold" }}>Lessons</Typography>
//                                     <Box>

//                                         <Tooltip title="Add New Lesson">
//                                             <span> {/* Wrapper to prevent tooltip from disappearing when disabled */}
//                                                 <IconButton
//                                                     onClick={() => { setShowLessonForm(true); setLessonFormInput(initialLessonFormState) }}
//                                                     disabled={showLessonForm && (!lessonFormInput || !lessonFormInput.ID)}
//                                                 >
//                                                     <AddIcon sx={{ border: "1px solid black", borderRadius: '4px', opacity: '60%', color: showLessonForm && (!lessonFormInput || !lessonFormInput.ID) ? "gray" : "#6ebe44" }} />
//                                                 </IconButton>
//                                             </span>
//                                         </Tooltip>

//                                     </Box>
//                                 </Box>
//                                 <CardContent>
//                                     <List>
//                                         {lessonList.map((lesson, index) => {
//                                             const questionsCount = lesson?.questions?.length ?? 0;
//                                             const firstQuestion = lesson?.questions?.[0]?.question || "";

//                                             return (
//                                                 <ListItem
//                                                     key={lesson.ID}
//                                                     onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleSelect(lesson.ID) }}
//                                                     sx={{
//                                                         display: "flex",
//                                                         flexDirection: "column",
//                                                         alignItems: "flex-start",
//                                                         backgroundColor: selectedLessonCard.ID === lesson.ID ? "#e3f2fd" : "#f8f9fa",
//                                                         borderRadius: 2,
//                                                         mb: 1,
//                                                         p: 2,
//                                                         cursor: "pointer",
//                                                     }}
//                                                 >
//                                                     <Box display="flex" alignItems="center" gap={1} width="100%" justifyContent="space-between">
//                                                         <Box display="flex" alignItems="center" gap={1}>
//                                                             <Chip label={index + 1} color="success" size="small"
//                                                                 // sx={{ fontWeight: "bold", borderRadius: "4px" }}

//                                                                 sx={{
//                                                                     fontWeight: "bold", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "150px", borderRadius: '4px'
//                                                                 }}

//                                                             />
//                                                             <Typography sx={{ fontWeight: "bold" }}>Lesson {index + 1}: {lesson.lessonTitleName}</Typography>
//                                                         </Box>

//                                                         <IconButton size="small"
//                                                             onClick={(e) => {
//                                                                 e.preventDefault(); e.stopPropagation();
//                                                                 handleRemoveLesson(lesson.ID)
//                                                             }}
//                                                             disabled={removeLessonMutation?.isPending}
//                                                         >
//                                                             <CloseIcon />
//                                                         </IconButton>

//                                                     </Box>
//                                                     {/* <Button size="small" sx={{ color: "#6ebe44", textDecoration: "underline", mt: 1 }} >
//                                                         <PlayCircleIcon fontSize="small" /> Video
//                                                     </Button> */}
//                                                     {/*                                                     
//                                                     <Typography variant="body2" px={1} >Q1: {firstQuestion}</Typography> */}
//                                                     <Button size="small" sx={{ color: "#6ebe44", textDecoration: "underline", display: "flex", alignItems: "center", gap: 1 }} >
//                                                         <PlayArrowIcon fontSize="small" /> Video
//                                                     </Button>

//                                                     <Box display="flex" alignItems="center" gap={1}>
//                                                         <PlayArrowIcon fontSize="small" sx={{ color: "#6ebe44" }} />
//                                                         <Typography variant="body2">Q1: {firstQuestion}</Typography>
//                                                     </Box>



//                                                     <Tooltip title={questionsCount > 0 ? `Total Questions Added ${questionsCount}` : ""}>
//                                                         <Button size="small" sx={{ color: "#6ebe44", textDecoration: "underline" }} onClick={(e) => {
//                                                             e.preventDefault(); e.stopPropagation();
//                                                             handleToggleQuestion(index)
//                                                         }}>
//                                                             Add Question
//                                                         </Button>
//                                                     </Tooltip>

//                                                 </ListItem>
//                                             )
//                                         })}
//                                     </List>
//                                 </CardContent>
//                             </Card>
//                         </Box>
//                     </Grid>

//                     {/* Middle section Editor */}
//                     <Grid item xs={12} sm={6}>
//                         <Card sx={{ padding: "2rem", borderRadius: "2px", height: "80vh", overflow: "auto" }}>
//                             <Grid>

//                                 {showLessonForm && (
//                                     <>
//                                         <Typography variant="h4" sx={{ mb: 1, fontWeight: "bold" }}>Lesson Information</Typography>

//                                         <Typography variant="h6" sx={{ mb: 1, }}
//                                         >
//                                             {/* Lesson Title  */}
//                                             Training Program Name
//                                             <span style={{ color: "red" }}>*</span></Typography>
//                                         <TextField fullWidth variant="standard" name="lessonTitleName" value={lessonFormInput.lessonTitleName} onChange={handleChange} error={!!lessonErrors.lessonTitleName} helperText={lessonErrors.lessonTitleName} defaultValues="Intro to Critical Care" />



//                                         <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
//                                             {/* Lesson Description */}
//                                             Training Description
//                                         </Typography>
//                                         <TextField fullWidth multiline rows={2} variant="standard" placeholder="In this section you will learn ..." name="lessonDescription" value={lessonFormInput.lessonDescription} onChange={handleChange} />

//                                         <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
//                                             {/* Lesson Objective */}
//                                             Objective
//                                         </Typography>
//                                         <TextField fullWidth variant="standard" placeholder="Safety training is essential for ensuring a secure and healthy work environment..." name="lessonObjective" value={lessonFormInput.lessonObjective} onChange={handleChange} />

//                                         <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>No. of Exam Questions <span style={{ color: "red" }}>*</span></Typography>
//                                         <TextField fullWidth variant="standard" placeholder="5" name="showNoOfQuestion" value={lessonFormInput.showNoOfQuestion} onChange={handleChange} error={!!lessonErrors.showNoOfQuestion} helperText={lessonErrors.showNoOfQuestion} />



//                                         <FormControl mt={2}>
//                                             <RadioGroup
//                                                 row
//                                                 value={lessonFormInput.trainingType}
//                                                 onChange={handleRadioChange}
//                                                 name="row-radio-buttons-group"
//                                             >
//                                                 <FormControlLabel value="Videos" control={<Radio />} label="Videos" />
//                                                 <FormControlLabel value="Pdf" control={<Radio />} label="Pdf" />
//                                             </RadioGroup>
//                                         </FormControl>

//                                         {/* Duration and Content URL fields only shown when "Videos" is selected */}
//                                         {lessonFormInput.trainingType === "Videos" && (
//                                             <>
//                                                 <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
//                                                     Duration (Minutes)
//                                                     <span style={{ color: "red" }}>*</span>
//                                                 </Typography>
//                                                 <TextField
//                                                     fullWidth
//                                                     variant="standard"
//                                                     placeholder="10.00"
//                                                     name="lessonVideoDuration"
//                                                     value={lessonFormInput.lessonVideoDuration}
//                                                     onChange={(e) => {
//                                                         const value = e.target.value;
//                                                         if (value === "") {
//                                                             setLessonFormInput({ ...lessonFormInput, lessonVideoDuration: value });
//                                                             return;
//                                                         }
//                                                         const regex = /^(?:\d{1,2}(\.\d{0,2})?)?$/;
//                                                         if (regex.test(value)) {
//                                                             setLessonFormInput({ ...lessonFormInput, lessonVideoDuration: value });
//                                                         }
//                                                     }}
//                                                     inputProps={{
//                                                         inputMode: "decimal",
//                                                         pattern: "^[0-9]{1,2}(\\.[0-9]{1,2})?$",
//                                                         step: "0.01",
//                                                         min: "0.01",
//                                                         max: "99.99",
//                                                     }}
//                                                     error={!!lessonErrors.lessonVideoDuration}
//                                                     helperText={lessonErrors.lessonVideoDuration}
//                                                 />

//                                                 <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
//                                                     Content (Video URL) <span style={{ color: "red" }}>*</span>
//                                                 </Typography>
//                                                 <TextField
//                                                     fullWidth
//                                                     variant="standard"
//                                                     placeholder="https://"
//                                                     name="lessonVideoUrl"
//                                                     value={lessonFormInput.lessonVideoUrl}
//                                                     onChange={handleChange}
//                                                     error={!!lessonErrors.lessonVideoUrl}
//                                                     helperText={lessonErrors.lessonVideoUrl}
//                                                 />
//                                             </>
//                                         )}

//                                         {lessonFormInput.trainingType === 'Pdf' && (
//                                             <Paper elevation={3} style={{ padding: 40, textAlign: "start", width: '70%', margin: "auto" }}>
//                                                 <Typography gutterBottom sx={{ fontWeight: 600, fontSize: "24px" }}>Upload Learning Material</Typography>

//                                                 {!(uploadedFilePath || pdfUrl) && (
//                                                     <div
//                                                         onDrop={handleDrop}
//                                                         onDragOver={(e) => e.preventDefault()}
//                                                         style={{
//                                                             position: 'relative',
//                                                             height: '150px',
//                                                             border: '2px dashed #6EBE44',
//                                                             borderRadius: '8px',
//                                                             display: 'flex',
//                                                             flexDirection: 'column',
//                                                             justifyContent: 'center',
//                                                             alignItems: 'center',
//                                                             padding: '16px'
//                                                         }}
//                                                     >
//                                                         <input
//                                                             type="file"
//                                                             accept=".pdf"
//                                                             style={{
//                                                                 height: '100%',
//                                                                 width: '100%',
//                                                                 position: 'absolute',
//                                                                 left: 0,
//                                                                 zIndex: 99,
//                                                                 opacity: 0,
//                                                                 cursor: 'pointer'
//                                                             }}
//                                                             onChange={(e) => {
//                                                                 const file = e.target.files[0];
//                                                                 if (!file) { setLessonErrors({ 'file': 'File is not selected' }); return };
//                                                                 if (!handleFileValidation(file)) { setLessonErrors({ 'file': 'File size exceeds 5MB' }); return; }
//                                                                 setFileName(file.name);
//                                                                 setUploadedFilePath(URL.createObjectURL(file));
//                                                                 setLessonFormInput({ ...lessonFormInput, file: file });
//                                                                 setPdfUrl('')


//                                                             }}
//                                                         />
//                                                         <VscCloudUpload style={{ color: '#6EBe44', transform: "scaleX(-1)" }} size={40} />
//                                                         <h4>Drag & drop or <strong>Browse</strong></h4>
//                                                         <p style={{ fontSize: "12px", color: "#000000", opacity: "60%" }}>
//                                                             Only PDF allowed
//                                                         </p>
//                                                     </div>
//                                                 )}

//                                                 {lessonErrors?.file && <Typography color="error" variant="caption">{lessonErrors?.file}</Typography>}
//                                                 {(uploadedFilePath || pdfUrl) && (
//                                                     <>
//                                                         <Box mt={2} display="flex" alignItems="center" justifyContent="space-between">
//                                                             <Box display="flex" alignItems="center">
//                                                                 <InsertDriveFileIcon sx={{ color: "#6EBe44", mr: 1 }} />
//                                                                 <Typography variant="body2">{fileName}</Typography>
//                                                             </Box>
//                                                             <Button onClick={() => setOpen(true)} sx={{ border: "1px solid #ee8d80", color: "#ee8d80" }}>Preview</Button>
//                                                             <Button onClick={() => { setPdfUrl(''); setFileName(''); setUploadedFilePath(''); setLessonFormInput(prev => ({ ...prev, file: null })); }} variant="outlined">Remove</Button>
//                                                         </Box>
//                                                     </>
//                                                 )}
//                                             </Paper>
//                                         )}








//                                         <Box
//                                             sx={{
//                                                 display: "flex",
//                                                 justifyContent: "flex-end",
//                                                 gap: 2,
//                                                 alignItems: "bottom",
//                                                 marginTop: 4
//                                             }}>

//                                             <Button
//                                                 className="gradientAdminThemeColor"

//                                                 onClick={handleSaveLessonFormInput}
//                                                 disabled={isPending}
//                                             >
//                                                 {isPending ? <CircularProgress size={24} /> : lessonFormInput.ID ? "Update & Next" : "Save & Add Questions"}

//                                             </Button>
//                                         </Box>
//                                     </>
//                                 )}
//                                 {showQuestionForm && (
//                                     <>
//                                         <Box display="flex" alignItems="center" gap={1} width="100%" justifyContent="space-between">
//                                             <Box display="flex" alignItems="center" gap={1}>
//                                                 <Chip label="L" color="success" size="small" sx={{ fontWeight: "bold", borderRadius: "4px" }} />
//                                                 <Typography sx={{ fontWeight: "bold" }}>Lesson: {selectedLessonCard.lessonTitleName}</Typography>
//                                             </Box>



//                                         </Box>
//                                         <Box display="flex" alignItems="center" gap={1} width="100%" justifyContent="space-between">
//                                             <Chip label={currentQuestionIndex + 1} sx={{ backgroundColor: "#6ebe44", color: "#ffffff", fontWeight: "bold", borderRadius: "4px" }} />

//                                             <TextField
//                                                 fullWidth
//                                                 variant="standard"
//                                                 margin="normal"
//                                                 placeholder="Enter question"
//                                                 value={questions[currentQuestionIndex]?.question || ""}
//                                                 onChange={handleQuestionChange}

//                                             />
//                                             {/* Remove Question Button */}
//                                             <IconButton
//                                                 onClick={() => handleRemoveQuestion(currentQuestionIndex)}
//                                                 sx={{ color: "red" }}
//                                             >
//                                                 <CloseIcon />
//                                             </IconButton>
//                                         </Box>


//                                         <Box mt={3} sx={{ width: "300px" }}>

//                                             {questions[currentQuestionIndex]?.choices.map((choice, index) => (
//                                                 <Box key={index} sx={{ display: "flex", alignItems: "center", border: "1px solid #6ebe44", borderRadius: "8px", backgroundColor: "#f2f9f1", padding: "8px", marginBottom: "8px" }}>
//                                                     <Typography sx={{ fontWeight: "bold", color: "#6ebe44", border: "1px solid #6ebe44", borderRadius: "50%", width: "24px", height: "24px", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "8px" }}>
//                                                         {String.fromCharCode(65 + index)}
//                                                     </Typography>
//                                                     <TextField
//                                                         variant="standard"
//                                                         fullWidth
//                                                         placeholder="Enter option value"
//                                                         value={choice.option} // ✅ Accessing option instead of whole object
//                                                         onChange={(e) => {
//                                                             setQuestions(prevQuestions => {
//                                                                 const updatedQuestions = [...prevQuestions];
//                                                                 const updatedChoices = [...updatedQuestions[currentQuestionIndex].choices]; // ✅ Create a new array

//                                                                 updatedChoices[index] = {
//                                                                     ...updatedChoices[index], // Preserve existing object properties
//                                                                     option: e.target.value, // ✅ Update only the `option`
//                                                                 };

//                                                                 updatedQuestions[currentQuestionIndex] = {
//                                                                     ...updatedQuestions[currentQuestionIndex], // Preserve existing question properties
//                                                                     choices: updatedChoices, // ✅ Use new choices array
//                                                                 };

//                                                                 return updatedQuestions;
//                                                             });
//                                                         }}
//                                                         InputProps={{
//                                                             disableUnderline: true,
//                                                             sx: { fontStyle: "italic", color: "#6ebe44" },
//                                                         }}
//                                                     />
//                                                     <IconButton
//                                                         onClick={() => handleRemoveChoice(index)}
//                                                         sx={{ color: "#6ebe44", marginLeft: "8px" }}
//                                                     >
//                                                         <CloseIcon />
//                                                     </IconButton>
//                                                 </Box>
//                                             ))}


//                                             <Typography
//                                                 onClick={handleAddChoice}
//                                                 sx={{ color: "#6ebe44", cursor: "pointer", fontStyle: "italic", textDecoration: "underline" }}
//                                             >
//                                                 +Add choice
//                                             </Typography>
//                                             <Typography variant="h6" sx={{ mt: 2 }}>Select Correct Answer</Typography>
//                                             <RadioGroup
//                                                 value={questions[currentQuestionIndex]?.correctAnswer || ""}

//                                                 onChange={(e) => {
//                                                     setQuestions(prevQuestions => {
//                                                         const updatedQuestions = [...prevQuestions];

//                                                         // Create a new object for the current question
//                                                         updatedQuestions[currentQuestionIndex] = {
//                                                             ...updatedQuestions[currentQuestionIndex], // ✅ Spread to maintain immutability
//                                                             correctAnswer: e.target.value, // ✅ Update `correctAnswer`
//                                                         };

//                                                         return updatedQuestions;
//                                                     });
//                                                 }}

//                                             >
//                                                 {questions[currentQuestionIndex]?.choices.map((choice, index) => (
//                                                     <FormControlLabel
//                                                         key={index}
//                                                         value={choice.option} // ✅ Store only the option string
//                                                         control={<Radio />}
//                                                         label={choice.option} // ✅ Display only the option string
//                                                     />
//                                                 ))}
//                                             </RadioGroup>
//                                         </Box>

//                                         <Box
//                                             sx={{
//                                                 display: "flex",
//                                                 justifyContent: "end",
//                                                 gap: 2,
//                                                 alignItems: "bottom",
//                                                 marginTop: 5
//                                             }}>
//                                             <Typography
//                                                 sx={{
//                                                     color: "#6ebe44",
//                                                     cursor: "pointer",
//                                                     fontStyle: "italic",
//                                                     textDecoration: "underline",
//                                                     display: "inline-block",
//                                                     marginTop: "10px",
//                                                 }}
//                                                 onClick={handleSaveAndAddNew}

//                                             >
//                                                 Save & Add Question
//                                             </Typography>

//                                             {currentQuestionIndex === questions.length - 1 && (
//                                                 <Button
//                                                     className="gradientAdminThemeColor"
//                                                     onClick={handleSaveLessonWithQuestions}
//                                                     disabled={saveQuestionMutation.isPending}
//                                                 >
//                                                     {saveQuestionMutation?.isPending ? <CircularProgress size={24} /> : "Save"}
//                                                 </Button>
//                                             )}
//                                         </Box>
//                                         <Divider sx={{ marginTop: 3 }} />
//                                         <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: 1 }}>
//                                             <Button
//                                                 disabled={currentQuestionIndex === 0}
//                                                 onClick={handleQuestionBack}
//                                             >
//                                                 Back
//                                             </Button>

//                                             <Typography variant="h6">
//                                                 Question {currentQuestionIndex + 1} of {questions.length}
//                                             </Typography>

//                                             <Button
//                                                 disabled={currentQuestionIndex === questions.length - 1}
//                                                 onClick={handleQuestionNext}
//                                             >
//                                                 Next
//                                             </Button>
//                                         </Box>
//                                     </>
//                                 )}

//                             </Grid>

//                         </Card>
//                     </Grid>

//                     {/* Learning Settings */}
//                     <Grid item xs={12} sm={3} >
//                         <form onSubmit={handleSubmit(submitAddDocument)}>
//                             <Card
//                                 sx={{
//                                     padding: "2rem", display: "flex", borderRadius: "2px", flex: 1, overflowY: "auto", flexDirection: "column",
//                                     height: "80vh",
//                                 }}>

//                                 <Box
//                                     sx={{
//                                         display: "flex",
//                                         flexDirection: "column",
//                                         gap: 2,
//                                         mb: 3,
//                                         width: "100%",
//                                     }}>
//                                     <Typography variant="h4" component="div" fontWeight="bold">
//                                         {/* Learning Settings */}
//                                         Settings
//                                     </Typography>
//                                     <Divider />

//                                     <TextField
//                                         label="Traning Name"
//                                         variant="outlined"
//                                         fullWidth
//                                         margin="normal"
//                                         autoFocus={true}

//                                         // InputProps={{ style: { height: '50px' } }}
//                                         sx={{
//                                             "& .MuiOutlinedInput-input": {
//                                                 padding: 1.94,
//                                             },
//                                             "& .MuiFormHelperText-root": {
//                                                 marginLeft: 0,
//                                                 marginTop: "4px",
//                                             },
//                                         }}
//                                         {...register("trainingCertificateName")}
//                                         error={!!errors.trainingCertificateName}
//                                         helperText={errors.trainingCertificateName?.message}
//                                     />



//                                     <FormControl fullWidth >
//                                         <Controller
//                                             name="JOBROLE_ID"
//                                             control={control}
//                                             render={({ field }) => (
//                                                 <>
//                                                     <TextField
//                                                         {...field}
//                                                         select
//                                                         label="Assign to Job Roles"
//                                                         onChange={(event) => {
//                                                             field.onChange(event.target.value); // Update form state
//                                                             handleRoleChange(event.target.value); // Custom handler if needed
//                                                         }}
//                                                         error={!!errors.JOBROLE_ID || isError}
//                                                         helperText={
//                                                             errors.JOBROLE_ID?.message ||
//                                                             (isError ? "Failed to fetch job roles. Please try again." : "")
//                                                         }
//                                                         disabled={isLoading} // Disable dropdown while loading
//                                                         InputProps={{
//                                                             endAdornment: isLoading && <CircularProgress size={24} />,
//                                                         }}
//                                                         SelectProps={{
//                                                             MenuProps: {
//                                                                 anchorOrigin: {
//                                                                     vertical: "bottom",
//                                                                     horizontal: "left",
//                                                                 },
//                                                                 transformOrigin: {
//                                                                     vertical: "top",
//                                                                     horizontal: "left",
//                                                                 },
//                                                                 getContentAnchorEl: null, // Ensures the menu doesn't anchor upwards
//                                                             },
//                                                         }}
//                                                     >
//                                                         <MenuItem disabled value="">Select</MenuItem>
//                                                         {fetchJobRole.map((role) => (
//                                                             <MenuItem key={role.ID} value={role.ID}>{role.ROLE_NAME}</MenuItem>
//                                                         ))}
//                                                     </TextField>
//                                                 </>
//                                             )}
//                                         />
//                                         <Box sx={{ mt: 2 }}>
//                                             {selectedRoles.length > 0 && (
//                                                 <Grid container spacing={1}>
//                                                     {selectedRoles.map((jobRoleID) => {
//                                                         const role = fetchJobRole.find((role) => role.ID === jobRoleID);
//                                                         if (!role) return null; // Prevent rendering if no role is found

//                                                         return (
//                                                             <Grid item xs={4} key={jobRoleID}>
//                                                                 <Chip
//                                                                     label={role.ROLE_NAME}
//                                                                     onDelete={() => handleChipDelete(jobRoleID)}
//                                                                     sx={{ borderRadius: 0.9 }}
//                                                                 />
//                                                             </Grid>
//                                                         );
//                                                     })}
//                                                 </Grid>
//                                             )}
//                                         </Box>
//                                     </FormControl>


//                                     <FormControl
//                                         fullWidth
//                                         sx={{ marginTop: 1 }}
//                                         error={!!errors.status}>
//                                         <InputLabel id="status-select-label">Status</InputLabel>
//                                         <Controller
//                                             name="status"
//                                             control={control}
//                                             render={({ field }) => (
//                                                 <Select
//                                                     autoFocus
//                                                     labelId="status-select-label"
//                                                     id="status-select"
//                                                     label="Status"
//                                                     {...field}
//                                                     error={!!errors.status}>
//                                                     <MenuItem value="Active">Active</MenuItem>
//                                                     <MenuItem value="Inactive">Inactive</MenuItem>
//                                                 </Select>
//                                             )}
//                                         />
//                                         {errors.status && (
//                                             <FormHelperText>
//                                                 {errors.status?.message}
//                                             </FormHelperText>
//                                         )}
//                                     </FormControl>


//                                     <FormControl fullWidth error={!!errors.requirementType}>

//                                         <Controller
//                                             name="requirementType"

//                                             control={control}
//                                             render={({ field }) => (
//                                                 <>
//                                                     <InputLabel id="demo-simple-select-label">Requirement</InputLabel>
//                                                     <Select
//                                                         // autoFocus
//                                                         labelId="demo-simple-select-label"
//                                                         id="requirement-select"
//                                                         label="Training Type"
//                                                         {...field}
//                                                         error={!!errors.requirementType}
//                                                     >
//                                                         <MenuItem disabled value="">Select Requirement</MenuItem>
//                                                         <MenuItem value="Optional">Optional</MenuItem>
//                                                         <MenuItem value="Mandatory">Mandatory</MenuItem>
//                                                     </Select></>
//                                             )}
//                                         />
//                                         {errors.requirementType && <FormHelperText error>{errors.requirementType?.message}</FormHelperText>}
//                                     </FormControl>



//                                     <TextField
//                                         label="How many Re-attempt"
//                                         variant="outlined"
//                                         fullWidth
//                                         type="text"
//                                         margin="normal"
//                                         inputProps={{
//                                             min: 1,
//                                             max: 9,
//                                             step: 1, // Ensures only whole numbers
//                                         }}

//                                         sx={{
//                                             "& .MuiOutlinedInput-input": {
//                                                 padding: 1.94,
//                                             },
//                                             "& .MuiFormHelperText-root": {
//                                                 marginLeft: 0,
//                                             },
//                                         }}
//                                         {...register("noOfReattempt")}
//                                         error={!!errors.noOfReattempt}
//                                         helperText={errors.noOfReattempt?.message}
//                                     />
//                                     <Box
//                                         sx={{
//                                             display: "flex",
//                                             justifyContent: "flex-end",
//                                             gap: 2,
//                                             alignItems: "bottom",
//                                         }}>
//                                         <Button
//                                             variant="outlined"
//                                             sx={{ width: "90px", color: "#6ebe44" }}

//                                             onClick={handleOpen}
//                                         >
//                                             Cancel
//                                         </Button>




//                                         <Button
//                                             //   variant="contained" sx={{ backgroundColor: '#6ebe44' }}
//                                             className="gradientAdminThemeColor"
//                                             type="submit"
//                                         >
//                                             {saveTrainingMutation?.isPending ? <CircularProgress size={24} /> : "Final & Save"}
//                                         </Button>
//                                     </Box>
//                                 </Box>

//                                 <Box
//                                     sx={{
//                                         display: "flex",
//                                         flexDirection: "column",
//                                         gap: 2,
//                                         width: "100%",
//                                     }}
//                                 >
//                                     {trainingLessonsErrors.length > 0 && (
//                                         <Grid container spacing={1} sx={{ mt: 0.5 }}>
//                                             {trainingLessonsErrors.map((error, index) => (
//                                                 <Grid item xs={12} key={index}>
//                                                     <Typography sx={{ color: "red", fontSize: "0.875rem" }}><span style={{ color: "red" }}>*</span>{error}</Typography>
//                                                 </Grid>
//                                             ))}
//                                         </Grid>
//                                     )}

//                                 </Box >
//                             </Card>
//                         </form >

//                     </Grid>
//                 </Grid>

//             </Grid >
//             {open && <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
//                 <DialogTitle sx={{ m: 0, p: 2 }}>
//                     PDF Document
//                     <IconButton
//                         aria-label="close"
//                         onClick={handleClose}
//                         sx={{ position: 'absolute', right: 8, top: 8, color: "#000000" }}
//                     >
//                         <CloseIcon />
//                     </IconButton>
//                 </DialogTitle>
//                 <DialogContent sx={{ display: 'flex', justifyContent: 'center' }}>
//                     <div style={{ width: '60%' }}>
//                         <PdfViewer file={pdfUrl || uploadedFilePath} />
//                     </div>
//                 </DialogContent>
//             </Dialog>}
//         </Grid >
//     );
// };

// export default memo(LessonList);




import { memo, useEffect, useState, useCallback } from "react";

import {
    Card,
    CardContent,
    TextField,
    Typography,
    Grid,
    Box,
    Button,
    IconButton,
    Divider,
    FormControl,
    InputLabel,
    FormHelperText,
    Select,
    MenuItem,
    Chip,
    CircularProgress,
    Tooltip,
    FormControlLabel,
    Radio,
    RadioGroup,
    Paper,
    Dialog,
    DialogContent,
    DialogTitle,
} from "@mui/material";

import { useNavigate, } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useTMutation } from "../../../../../utils/useTMutation";
import showToast from "../../../../../components/Hot-Toast/showToast";
import {
    emptyValues,
    previousStep,
    update,
} from "../../../../../slice/multiStepSlice";
import { useQuery } from "@tanstack/react-query";
import { fetchJobRoles } from "../../../../../utils/commonAPI";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import "react-phone-input-2/lib/style.css";
import CloseIcon from "@mui/icons-material/Close";
import { List, ListItem, } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import * as React from 'react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { VscCloudUpload } from 'react-icons/vsc';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import PdfViewer from "../../../../../components/PDFViewer/pdfViwer";
import { convertToFormData } from "../../../../../utils/genericMethod";
import { API_URL } from "../../../../../appConstants";

export const jobRoleSchema = z.object({
    trainingCertificateName: z.string().min(1, { message: "Document Name is required" }),
    requirementType: z.string().min(1, { message: "Requirement is required" }),
    JOBROLE_ID: z.array(z.string().uuid()).min(1, "At least one Job role must be selected"),
    status: z.string().min(1, { message: "Status is required" }),
    noOfReattempt: z
        .string()
        .min(1, { message: "No of Attempts is required" }) // Ensures input is not empty
        .transform((val) => Number(val)) // Convert string to number
        .refine((val) => val >= 1 && val <= 9, { message: "Attempts must be between 1 and 9" }),
});

function validateLessons(lessons) {
    let errors = [];
    if (lessons.length <= 0) {
        errors.push(`Lesson is missing or empty`);
    }
    lessons.forEach((lesson, lessonIndex) => {
        if (!lesson.lessonTitleName) {
            errors.push(`Lesson ${lessonIndex + 1}: lessonTitleName is missing or empty`);
        }
        if (!Array.isArray(lesson.questions) || lesson.questions.length === 0) {
            errors.push(`Lesson ${lessonIndex + 1}: questions array is missing or empty`);
        } else {
            if (lesson.questions.length < lesson.showNoOfQuestion) {
                errors.push(`Lesson ${lessonIndex + 1}: questions array has fewer questions (${lesson.questions.length}) than required (${lesson.showNoOfQuestion})`);
            }
            lesson.questions.forEach((question, questionIndex) => {
                if (!question.question) {
                    errors.push(`Lesson ${lessonIndex + 1}, Question ${questionIndex + 1}: question is missing or empty`);
                }
                if (!question.correctAnswer) {
                    errors.push(`Lesson ${lessonIndex + 1}, Question ${questionIndex + 1}: correctAnswer is missing`);
                }
                if (!Array.isArray(question.choices) || question.choices.length === 0) {
                    errors.push(`Lesson ${lessonIndex + 1}, Question ${questionIndex + 1}: choices array is missing or empty`);
                } else if (question.choices.length < 2) {
                    errors.push(`Lesson ${lessonIndex + 1}, Question ${questionIndex + 1}: choices array must have at least 2 options`);
                }
                question.choices.forEach((choice, choiceIndex) => {
                    if (!choice.option) {
                        errors.push(`Lesson ${lessonIndex + 1}, Question ${questionIndex + 1}, Choice ${choiceIndex + 1}: option is missing or empty`);
                    }
                });
            });
        }
    });
    return errors;
}

const LessonList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { values } = useSelector((state) => state?.multiStep); console.log("values", values);
    const { selectedTabData } = useSelector((state) => state.profileTabSection);
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const { userDetails } = useSelector(state => state?.user);
    const initialLessonFormState = { ID: undefined, lessonTitleName: "", lessonVideoDuration: "", lessonObjective: "", lessonVideoUrl: "", showNoOfQuestion: 3, lessonDescription: "", file: null, trainingType: 'Videos' };
    const initialQuestionFormState = {
        question: "",
        choices: [{ option: "", ID: undefined }], // ✅ Correct structure
        correctAnswer: null
    };
    const [trainingLessonsErrors, setTrainingLessonsErrors] = useState([]);
    const [selectedRoles, setSelectedRoles] = useState([]);
    //Question related useState
    const [showQuestionForm, setShowQuestionForm] = useState(false);
    const [questions, setQuestions] = useState(initialQuestionFormState);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    //Lesson related useState
    const [lessonErrors, setLessonErrors] = useState({});//use for LessonForm Input errors
    const [lessonList, setLessonList] = useState([]);
    const [selectedLessonCard, setSelectedLessonCard] = useState(null);
    const [showLessonForm, setShowLessonForm] = useState(false);
    const [lessonFormInput, setLessonFormInput] = useState(initialLessonFormState); // Changed to single object
    const [isFirstRender, setIsFirstRender] = useState(true);
    const [fileName, setFileName] = useState(null); // Store uploaded file name
    const [uploadedFilePath, setUploadedFilePath] = useState('');
    const [pdfUrl, setPdfUrl] = useState('');
    const { controlBy, controlAction } = useSelector(state => state.user);
    console.log("values", values)

    const validateForm = () => {
        let newErrors = {};
        if (lessonFormInput.trainingType === "Videos") {
            ["lessonTitleName", "lessonVideoDuration", "lessonVideoUrl", "showNoOfQuestion"].forEach((key) => {
                if (!lessonFormInput[key]) {
                    newErrors[key] = "This field is required";
                }
            });
        } else if (lessonFormInput.trainingType === "Pdf") {
            ["lessonTitleName", "file", "showNoOfQuestion"].forEach((key) => {
                if (!lessonFormInput[key] || lessonFormInput[key] === null) {
                    newErrors[key] = "This field is required";
                }
            });
        } else if (lessonFormInput.trainingType === "Both") {
            console.log("lessonFormInput",lessonFormInput);
            // Validate both video and PDF fields for 'Both' option
            if (!lessonFormInput.lessonTitleName) {
                newErrors.lessonTitleName = "This field is required";
            }
            if (!lessonFormInput.lessonVideoDuration) {
                newErrors.lessonVideoDuration = "This field is required";
            }
            if (!lessonFormInput.lessonVideoUrl) {
                newErrors.lessonVideoUrl = "This field is required";
            }
            if (!lessonFormInput.file) { 
                newErrors.file = "This field is required";
            }
            if (!lessonFormInput.showNoOfQuestion) {
                newErrors.showNoOfQuestion = "This field is required";
            }
        }
        setLessonErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    console.log("lessonErrors", lessonErrors)

    const { data: fetchJobRole = [], isLoading, isError, } = useQuery({
        queryKey: ["jobRoles"],
        queryFn: fetchJobRoles,
        staleTime: 60000 * 2,
    });

    const { mutateAsync, isPending } = useTMutation("/addUpdateTrainingLesson", "post", (response) => {
        showToast(response.STATUS ? "success" : "error", response.MESSAGE)
        return response;
    });

    const saveQuestionMutation = useTMutation('/addUpdateLessonQuestion', 'post', (data) => {
        showToast(data.STATUS ? "success" : "error", data.MESSAGE, 3000);
    });

    const RemoveQuestionMutation = useTMutation('/removeLessonQuestionByID', 'post', (data) => {
        showToast(data.STATUS ? "success" : "error", data.MESSAGE, 3000);
    });

    const removeLessonMutation = useTMutation('/removeLessonByID', 'post', (data) => {
        showToast(data.STATUS ? "success" : "error", data.MESSAGE, 3000);
    });

    const saveTrainingMutation = useTMutation('/addUpdateTrainingCertificates', 'post', (data) => {
        showToast(data.STATUS ? "success" : "error", data.MESSAGE, 3000);
    });

    const {
        control,
        register,
        setValue,
        clearErrors,
        trigger,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: zodResolver(jobRoleSchema),
        defaultValues: {
            trainingCertificateName: values?.trainingCertificateName || "",
            requirementType: values?.requirementType || "",
            status: values?.status || "Active",
            noOfReattempt: values?.noOfReattempt?.toString() || "3",
            JOBROLE_ID: values?.JOBROLE_ID || [],
        },
    });

    useEffect(() => {
        if (values?.lessonList?.length > 0 && lessonList?.length === 0 && isFirstRender) {
            // Only set the first lesson when lessonList is initially empty
            console.log("default set URL", values?.lessonList?.[0]?.file);
            setPdfUrl(API_URL + "user/viewFile?fileName=" + values?.lessonList?.[0]?.file)
            // setUploadedFilePath(values?.lessonList?.[0]?.file);
            setFileName(`${values?.lessonList?.[0]?.lessonTitleName} Document.pdf`)
            setQuestions(values?.lessonList?.[0]?.questions || []);
            setLessonList(values.lessonList);
            setSelectedLessonCard(values?.lessonList[0]);
            setLessonFormInput(values?.lessonList[0]);
            setShowLessonForm(true);
        }
        setIsFirstRender(false);
    }, [values?.lessonList]);

    useEffect(() => {
        if (values?.JOBROLE_ID?.length > 0) {
            setSelectedRoles(values?.JOBROLE_ID);
            setValue('JOBROLE_ID', values?.JOBROLE_ID);
        }
    }, [values?.JOBROLE_ID]);

    //Lesson related function
    const handleSelect = (lessonId) => {
        const selectedLesson = lessonList.find((lesson) => lesson.ID === lessonId);
        setSelectedLessonCard(selectedLesson);
        console.log("selected card URL", selectedLesson.file);
        setPdfUrl(API_URL + "user/viewFile?fileName=" + selectedLesson?.file)
        // setUploadedFilePath(selectedLesson?.file);
        setFileName(`${selectedLesson?.lessonTitleName} Document.pdf`)
        if (selectedLesson) {
            setLessonFormInput({ ...selectedLesson }); // Set form input with selected lesson
            setShowLessonForm(true); // Show the lesson form
            setShowQuestionForm(false); // Show the lesson form
            setQuestions(selectedLesson?.questions || [initialQuestionFormState]);
            setCurrentQuestionIndex(selectedLesson?.questions?.length || 0);
        }
    };

    const handleSaveLessonFormInput = async (e) => {

        e.preventDefault();
        e.stopPropagation();
        if (!validateForm()) return;

        const { ID, ...lessonData } = lessonFormInput; 

        const trainingCertificateID = values?.ID;

        const rawPayload = {
            trainingCertificateID,
            ...(ID ? { ID } : {}), 
            ...lessonData,
        };

        const formData = new FormData();
        // console.log("Hanlde Save Lesson Form input ", formData);


        // Append all properties from rawPayload, excluding file and lessonVideoUrl initially
        for (const key in rawPayload) {
            if (rawPayload.hasOwnProperty(key)) {
                if (key !== 'file' && key !== 'lessonVideoUrl') {
                    formData.append(key, rawPayload[key]);
                }
            }
        }

        console.log("key------------>>>>>>>>>",rawPayload);

        // Conditionally append file or video URL or both based on trainingType
        if (lessonFormInput.trainingType === 'Pdf' && lessonFormInput.file) {
            formData.append('file', lessonFormInput.file);
        } else if (lessonFormInput.trainingType === 'Videos' && lessonFormInput.lessonVideoUrl) {
            formData.append('lessonVideoUrl', lessonFormInput.lessonVideoUrl);
        } else if (lessonFormInput.trainingType === 'Both') {
            if (lessonFormInput.file) {
                formData.append('file', lessonFormInput.file);
            }
            if (lessonFormInput.lessonVideoUrl) {
                formData.append('lessonVideoUrl', lessonFormInput.lessonVideoUrl);
            }
        }

        const response = await mutateAsync(formData);

        if (response.STATUS) {
            // Set uploaded file path and name if a PDF was involved in the response
            if ((response?.OUTPUT?.trainingType === 'Pdf' || response?.OUTPUT?.trainingType === 'Both') && response?.OUTPUT?.file) {
                setPdfUrl(API_URL + "user/viewFile?fileName=" + response.OUTPUT?.file);
                setFileName(`${response.OUTPUT?.lessonTitleName} Document.pdf`);
            }

            setLessonList((prevLessons) => {
                const updatedLessons = ID
                    ? prevLessons.map((lesson) => (lesson.ID === ID ? { ...lesson, ...response.OUTPUT } : lesson)) 
                    : [...prevLessons, { ...response.OUTPUT, questions: [] }];
                console.log("updatedLessons", updatedLessons)
                dispatch(update({ lessonList: updatedLessons })); 
                return updatedLessons;
            });
            if (!ID) {
                setSelectedLessonCard({ ...response.OUTPUT, questions: [] }); 
                setQuestions([initialQuestionFormState]);
                setCurrentQuestionIndex(0);
            }
            setLessonFormInput(initialLessonFormState);
            setShowLessonForm(false);
            setShowQuestionForm(true);
        }
    };

    const handleRemoveLesson = async (lessonID) => {
        const response = await removeLessonMutation.mutateAsync({ ID: lessonID });
        if (response.STATUS) {
            setLessonList((prevLessons) => {
                const updatedLessons = prevLessons.filter((lesson) => lesson.ID !== lessonID);
                setShowQuestionForm(false);
                let newSelectedLesson = null;
                const removedIndex = prevLessons.findIndex((lesson) => lesson.ID === lessonID);
                if (selectedLessonCard?.ID === lessonID) {
                    if (updatedLessons.length > 0) {
                        if (removedIndex < updatedLessons.length) {
                            newSelectedLesson = updatedLessons[removedIndex]; 
                        } else {
                            newSelectedLesson = updatedLessons[updatedLessons.length - 1]; 
                        }
                    }
                    setSelectedLessonCard(newSelectedLesson);
                    if (newSelectedLesson) {
                        handleSelect(newSelectedLesson.ID);
                    } else {
                        setLessonFormInput(initialLessonFormState);
                    }
                }
                return updatedLessons;
            });
        }
    };

    const handleToggleQuestion = () => {
        setShowLessonForm(false)
        setShowQuestionForm((prev) => !prev);
    };

    const handleChipDelete = (jobRoleID) => {
        setSelectedRoles((prev) => prev.filter((id) => id !== jobRoleID));
        setValue(
            "JOBROLE_ID",
            selectedRoles.filter((id) => id !== jobRoleID)
        );
        clearErrors("JOBROLE_ID");
    };

    const handleRoleChange = (selectedRoleId) => {
        if (!selectedRoles.includes(selectedRoleId)) {
            const updatedRoles = [...selectedRoles, selectedRoleId];
            setSelectedRoles(updatedRoles);
            setValue("JOBROLE_ID", updatedRoles);
            trigger("JOBROLE_ID");
        }
    };

    const submitAddDocument = async (data) => {
        try {
            const validationErrors = validateLessons(lessonList);
            setTrainingLessonsErrors(validationErrors)
            if (validationErrors.length > 0) {
                console.log("Validation Errors:", validationErrors);
                return;
            }
            const response = await saveTrainingMutation.mutateAsync({ ...data, USER_ID: userDetails?.ID, ID: values?.ID });
            if (response.STATUS) {
                dispatch(emptyValues());
                navigate("/admin/profile-criteria/LearningDocuments");
            }
        } catch (error) {
            console.error("Add Request failed:", error);
            showToast("error", "Something went wrong, Please try again", 3000);
        }
    };

    const handleChange = (e) => {
        setLessonFormInput({ ...lessonFormInput, [e.target.name]: e.target.value });
    };

    //MCQ related function
    const saveQuestionAndOptions = (callback) => {
        const currentQuestion = questions[currentQuestionIndex];
        if (!currentQuestion || !currentQuestion.question || currentQuestion.choices.length <= 1 || currentQuestion.correctAnswer === null) {
            showToast('error', "Please complete the question and select a correct answer.");
            return;
        }
        setLessonList(prevLessons => {
            const updatedLessons = prevLessons.map(lesson => {
                if (lesson.ID !== selectedLessonCard.ID) return lesson;
                const updatedQuestions = lesson.questions ? [...lesson.questions] : [];
                if (currentQuestionIndex < updatedQuestions.length) {
                    updatedQuestions[currentQuestionIndex] = questions[currentQuestionIndex];
                } else {
                    updatedQuestions.push(questions[currentQuestionIndex]);
                }
                return { ...lesson, questions: updatedQuestions };
            });
            dispatch(update({ lessonList: updatedLessons }));
            // Call the callback only if save was successful
            if (callback) callback();
            return updatedLessons;
        });
    };

    const handleSaveAndAddNew = () => {
        // when callback comes after callback add new question runs
        saveQuestionAndOptions(() => {
            setQuestions(prevQuestions => [
                ...prevQuestions,
                { question: "", choices: [{ option: "", ID: undefined }], correctAnswer: null }
            ]);
            setCurrentQuestionIndex(prevIndex => prevIndex + 1);
        });
    };

    const handleQuestionBack = () => {
        saveQuestionAndOptions(() => {
            setCurrentQuestionIndex((prev) => prev - 1)
        })
    }

    const handleQuestionNext = () => {
        saveQuestionAndOptions(() => {
            setCurrentQuestionIndex((prev) => prev + 1)
        })
    }

    const handleQuestionChange = (e) => {
        console.log("currentQuestionIndex:", currentQuestionIndex, "questions:", questions);
        if (!questions[currentQuestionIndex]) {
            setQuestions((prevQuestions) => {
                const newQuestions = [...prevQuestions];
                newQuestions[currentQuestionIndex] = { question: e.target.value, choices: [{ option: "", ID: undefined }], correctAnswer: null };
                return newQuestions;
            });
        } else {
            setQuestions((prevQuestions) =>
                prevQuestions.map((q, index) =>
                    index === currentQuestionIndex ? { ...q, question: e.target.value } : q
                )
            );
        }
    };

    const handleAddChoice = () => {
        const currentChoices = questions[currentQuestionIndex].choices;
        if (currentChoices.some(choice => choice.option.trim() === "")) {
            showToast("error", "Please fill all options before adding a new one.");
            return;
        }
        if (currentChoices.length >= 5) {
            showToast("error", "You can add up to 5 options only.");
            return;
        }
        setQuestions(prevQuestions => {
            const updatedQuestions = [...prevQuestions];
            updatedQuestions[currentQuestionIndex] = {
                ...updatedQuestions[currentQuestionIndex],
                choices: [...updatedQuestions[currentQuestionIndex].choices, { option: "", ID: undefined }],
            };
            return updatedQuestions;
        });
    };

    const handleRemoveQuestion = async (index) => {
        if (questions.length === 0) {
            showToast("error", "At least one question is required.");
            return;
        }
        const questionToRemove = questions[index];
        if (questionToRemove?.ID) {
            const response = await RemoveQuestionMutation.mutateAsync({ ID: questionToRemove.ID });
            if (!response.STATUS) return;
        }
        const updatedQuestions = questions.filter((_, i) => i !== index);
        setQuestions(updatedQuestions);
        setCurrentQuestionIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : 0));
        setLessonList((prevLessons) => {
            const updatedLessons = prevLessons.map((lesson) => {
                if (lesson.ID === selectedLessonCard.ID) {
                    return { ...lesson, questions: updatedQuestions };
                }
                return lesson;
            });
            dispatch(update({ lessonList: updatedLessons }));
            return updatedLessons;
        });
    };

    const handleRemoveChoice = (index) => {
        setQuestions(prevQuestions => {
            const updatedQuestions = [...prevQuestions];
            const currentChoices = updatedQuestions[currentQuestionIndex].choices;
            if (currentChoices.length <= 1) {
                showToast("error", "At least one choice is required.");
                return prevQuestions;
            }
            const updatedChoices = currentChoices.filter((_, i) => i !== index);
            let updatedCorrectAnswer = updatedQuestions[currentQuestionIndex].correctAnswer;
            if (updatedCorrectAnswer === index) {
                updatedCorrectAnswer = null;
            } else if (updatedCorrectAnswer > index) {
                updatedCorrectAnswer -= 1;
            }
            updatedQuestions[currentQuestionIndex] = {
                ...updatedQuestions[currentQuestionIndex],
                choices: updatedChoices,
                correctAnswer: updatedCorrectAnswer,
            };
            return updatedQuestions;
        });
    };

    const handleSaveLessonWithQuestions = async () => {
        const currentQuestion = questions[currentQuestionIndex];
        if (!currentQuestion || !currentQuestion.question || currentQuestion.choices.length <= 1 || currentQuestion.correctAnswer === null) {
            showToast('error', "Please complete the question and select a correct answer.");
            return;
        }
        const updatedLessons = lessonList.map(lesson => {
            if (lesson.ID === selectedLessonCard.ID) {
                const existingQuestions = lesson.questions || [];
                const updatedQuestions = [...existingQuestions];
                if (currentQuestionIndex < updatedQuestions.length) {
                    updatedQuestions[currentQuestionIndex] = currentQuestion;
                } else {
                    updatedQuestions.push(currentQuestion);
                }
                return { ...lesson, questions: updatedQuestions };
            }
            return lesson;
        });
        const response = await saveQuestionMutation.mutateAsync({
            trainingCertificateID: values?.ID,
            lessonID: selectedLessonCard?.ID,
            questions: updatedLessons.find(lesson => lesson.ID === selectedLessonCard.ID)?.questions || [],
        });
        if (response.STATUS) {
            setLessonList(updatedLessons);
            dispatch(update({ lessonList: updatedLessons }));
            setLessonFormInput(initialLessonFormState);
            setQuestions([initialQuestionFormState]);
            setCurrentQuestionIndex(0);
            setShowLessonForm(true);
            setShowQuestionForm(false);
        }
    };

    const handleRadioChange = (event) => {
        setLessonFormInput(prevLessonFormInput => ({ ...prevLessonFormInput, trainingType: event.target.value }))
    };

    const mutation = useTMutation("/profile", "patch", (data) => {
        if (data.STATUS) {
            showToast("success", data.MESSAGE, 3000);
            return data;
        } else {
            showToast("error", data.MESSAGE, 3000);
        }
    });

    const handleFileValidation = useCallback(
        (file) => {
            if (!file || file.size > 5 * 1024 * 1024) return false;
            const allowedTypes = ['application/pdf',];
            if (!allowedTypes.includes(file.type)) return false;
            setLessonErrors(prevErrors => {
                const { file, ...rest } = prevErrors;
                return rest;
            });
            return true;
        },
        []
    );

    const handleDrop = useCallback(
        (event) => {
            event.preventDefault();
            const file = event.dataTransfer.files[0];
            setLessonFormInput(prev => ({ ...prev, file: file }));
            
            if (handleFileValidation(file)) {
                setFileName(file.name);
                setUploadedFilePath(URL.createObjectURL(file));
            } else {
                setLessonErrors({ 'file': 'File size exceeds 5MB' });
            }
        },
        [handleFileValidation] 
    );

    return (
        <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start">
            {!values.REDIRECT && (
                <Button
                    onClick={() => dispatch(previousStep())}
                    startIcon={
                        <ArrowBackIosIcon sx={{ fontSize: "12px", color: "#000000" }} />
                    }
                    sx={{
                        textTransform: "none",
                        fontWeight: 500,
                        fontSize: "14px",
                        padding: 3,
                        minWidth: 0,
                        marginTop: -1,
                    }}></Button>
            )}
            <Grid item xs={12} mt={-2}>
                <Grid container spacing={2} direction="row">
                    {/* Lesson List Section */}
                    <Grid item xs={12} sm={3}>
                        <Box >
                            <Card sx={{
                                p: 2, borderRadius: 0, boxShadow: 3,
                                height: "80vh",
                                overflow: "auto"
                            }}
                            >
                                <Box px={3} display="flex" justifyContent="space-between" alignItems="center">
                                    <Typography variant="h4" sx={{ fontWeight: "bold" }}>Lessons</Typography>
                                    <Box>
                                        <Tooltip title="Add New Lesson">
                                            <span> {/* Wrapper to prevent tooltip from disappearing when disabled */}
                                                <IconButton
                                                    onClick={() => { setShowLessonForm(true); setLessonFormInput(initialLessonFormState) }}
                                                    disabled={showLessonForm && (!lessonFormInput || !lessonFormInput.ID)}
                                                >
                                                    <AddIcon sx={{ border: "1px solid black", borderRadius: '4px', opacity: '60%', color: showLessonForm && (!lessonFormInput || !lessonFormInput.ID) ? "gray" : "#6ebe44" }} />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Box>
                                </Box>
                                <CardContent>
                                    <List>
                                        {lessonList.map((lesson, index) => {
                                            const questionsCount = lesson?.questions?.length ?? 0;
                                            const firstQuestion = lesson?.questions?.[0]?.question || "";
                                            return (
                                                <ListItem
                                                    key={lesson.ID}
                                                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleSelect(lesson.ID) }}
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "flex-start",
                                                        backgroundColor: selectedLessonCard?.ID === lesson.ID ? "#e3f2fd" : "#f8f9fa",
                                                        borderRadius: 2,
                                                        mb: 1,
                                                        p: 2,
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <Box display="flex" alignItems="center" gap={1} width="100%" justifyContent="space-between">
                                                        <Box display="flex" alignItems="center" gap={1}>
                                                            <Chip label={index + 1} color="success" size="small"
                                                                sx={{
                                                                    fontWeight: "bold", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "150px", borderRadius: '4px'
                                                                }}
                                                            />
                                                            <Typography sx={{ fontWeight: "bold" }}>Lesson {index + 1}: {lesson.lessonTitleName}</Typography>
                                                        </Box>
                                                        <IconButton size="small"
                                                            onClick={(e) => {
                                                                e.preventDefault(); e.stopPropagation();
                                                                handleRemoveLesson(lesson.ID)
                                                            }}
                                                            disabled={removeLessonMutation?.isPending}
                                                        >
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </Box>
                                                    <Button size="small" sx={{ color: "#6ebe44", textDecoration: "underline", display: "flex", alignItems: "center", gap: 1 }} >
                                                        <PlayArrowIcon fontSize="small" /> Video
                                                    </Button>
                                                    <Box display="flex" flexDirection="column" alignItems="flex-start" gap={0.5}>
                                                        <Box display="flex" alignItems="center" gap={1}>
                                                            <PlayArrowIcon fontSize="small" sx={{ color: "#6ebe44" }} />
                                                            <Typography variant="body2">Q1: {firstQuestion}</Typography>
                                                        </Box>
                                                        <Typography fontWeight='bold' variant="body2" sx={{ fontSize: "12px", opacity: 0.8 }}>
                                                            Total No. of Questions: {questionsCount}
                                                        </Typography>
                                                    </Box>
                                                    <Tooltip title={questionsCount > 0 ? `Exam Questions: ${questionsCount}` : ""}>
                                                        <Button size="small" sx={{ color: "#6ebe44", textDecoration: "underline" }} onClick={(e) => {
                                                            e.preventDefault(); e.stopPropagation();
                                                            handleToggleQuestion(index)
                                                        }}>
                                                            Add Question
                                                        </Button>
                                                    </Tooltip>
                                                </ListItem>
                                            )
                                        })}
                                    </List>
                                </CardContent>
                            </Card>
                        </Box>
                    </Grid>
                    {/* Middle section Editor */}
                    <Grid item xs={12} sm={6}>
                        <Card sx={{ padding: "2rem", borderRadius: "2px", height: "80vh", overflow: "auto" }}>
                            <Grid>
                                {showLessonForm && (
                                    <>
                                        <Typography variant="h4" sx={{ mb: 1, fontWeight: "bold" }}>Lesson Information</Typography>
                                        <Typography variant="h6" sx={{ mb: 1, }}
                                        >
                                            Training Program Name
                                            <span style={{ color: "red" }}>*</span></Typography>
                                        <TextField fullWidth variant="standard" name="lessonTitleName" value={lessonFormInput.lessonTitleName} onChange={handleChange} error={!!lessonErrors.lessonTitleName} helperText={lessonErrors.lessonTitleName} />
                                        <Typography fontWeight="bold" variant="h6" sx={{ mt: 2, mb: 1 }}>
                                            Training Description
                                        </Typography>
                                        <TextField fullWidth multiline rows={3} variant="standard" placeholder="In this section you will learn ..." name="lessonDescription" value={lessonFormInput.lessonDescription} onChange={handleChange} />
                                        <Typography fontWeight="bold" variant="h6" sx={{ mt: 2, mb: 1 }}>
                                            Objective
                                        </Typography>
                                        <TextField fullWidth multiline rows={3} variant="standard" placeholder="Safety training is essential for ensuring a secure and healthy work environment..." name="lessonObjective" value={lessonFormInput.lessonObjective} onChange={handleChange} />
                                        <Typography fontWeight="bold" variant="h6" sx={{ mt: 2, mb: 1 }}>No. of Exam Questions <span style={{ color: "red" }}>*</span></Typography>
                                        <TextField fullWidth variant="standard" placeholder="5" name="showNoOfQuestion" value={lessonFormInput.showNoOfQuestion} onChange={handleChange} error={!!lessonErrors.showNoOfQuestion} helperText={lessonErrors.showNoOfQuestion} />
                                        <FormControl mt={2}>
                                            <RadioGroup
                                                row
                                                value={lessonFormInput.trainingType}
                                                onChange={handleRadioChange}
                                                name="row-radio-buttons-group"
                                            >
                                                <FormControlLabel value="Videos" control={<Radio />} label="Videos" />
                                                <FormControlLabel value="Pdf" control={<Radio />} label="Pdf" />
                                                <FormControlLabel value="Both" control={<Radio />} label="Both" />
                                            </RadioGroup>
                                        </FormControl>
                                        {/* Duration and Content URL fields only shown when "Videos" or "Both" is selected */}
                                        {(lessonFormInput.trainingType === "Videos" || lessonFormInput.trainingType === "Both") && (
                                            <>
                                                <Typography fontWeight="bold"    variant="h6" sx={{ mt: 2, mb: 1 }}>
                                                    Duration (Minutes)
                                                    <span style={{ color: "red" }}>*</span>
                                                </Typography>
                                                <TextField
                                                    fullWidth
                                                    variant="standard"
                                                    placeholder="10.00"
                                                    name="lessonVideoDuration"
                                                    value={lessonFormInput.lessonVideoDuration}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (value === "") {
                                                            setLessonFormInput({ ...lessonFormInput, lessonVideoDuration: value });
                                                            return;
                                                        }
                                                        const regex = /^(?:\d{1,2}(\.\d{0,2})?)?$/;
                                                        if (regex.test(value)) {
                                                            setLessonFormInput({ ...lessonFormInput, lessonVideoDuration: value });
                                                        }
                                                    }}
                                                    inputProps={{
                                                        inputMode: "decimal",
                                                        pattern: "^[0-9]{1,2}(\\.[0-9]{1,2})?$",
                                                        step: "0.01",
                                                        min: "0.01",
                                                        max: "99.99",
                                                    }}
                                                    error={!!lessonErrors.lessonVideoDuration}
                                                    helperText={lessonErrors.lessonVideoDuration}
                                                />
                                                <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
                                                    Content (Video URL) <span style={{ color: "red" }}>*</span>
                                                </Typography>
                                                <TextField
                                                    fullWidth
                                                    variant="standard"
                                                    placeholder="https://"
                                                    name="lessonVideoUrl"
                                                    value={lessonFormInput.lessonVideoUrl}
                                                    onChange={handleChange}
                                                    error={!!lessonErrors.lessonVideoUrl}
                                                    helperText={lessonErrors.lessonVideoUrl}
                                                />
                                            </>
                                        )}
                                        {(lessonFormInput.trainingType === 'Pdf' || lessonFormInput.trainingType === "Both") && (
                                            <Paper elevation={3} style={{ padding: 40, textAlign: "start", width: '70%', margin: "auto" }}>
                                                <Typography gutterBottom sx={{ fontWeight: 600, fontSize: "24px" }}>Upload Learning Material</Typography>
                                                {!(uploadedFilePath || pdfUrl) && (
                                                    <div
                                                        onDrop={handleDrop}
                                                        onDragOver={(e) => e.preventDefault()}
                                                        style={{
                                                            position: 'relative',
                                                            height: '150px',
                                                            border: '2px dashed #6EBE44',
                                                            borderRadius: '8px',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            padding: '16px'
                                                        }}
                                                    >
                                                        <input
                                                            type="file"
                                                            accept=".pdf"
                                                            style={{
                                                                height: '100%',
                                                                width: '100%',
                                                                position: 'absolute',
                                                                left: 0,
                                                                zIndex: 99,
                                                                opacity: 0,
                                                                cursor: 'pointer'
                                                            }}
                                                            onChange={(e) => {
                                                                const file = e.target.files[0];
                                                                if (!file) { setLessonErrors({ 'file': 'File is not selected' }); return };
                                                                if (!handleFileValidation(file)) { setLessonErrors({ 'file': 'File size exceeds 5MB' }); return; }
                                                                setFileName(file.name);
                                                                setUploadedFilePath(URL.createObjectURL(file));
                                                                setLessonFormInput({ ...lessonFormInput, file: file });
                                                                setPdfUrl('')
                                                            }}
                                                        />
                                                        <VscCloudUpload style={{ color: '#6EBe44', transform: "scaleX(-1)" }} size={40} />
                                                        <h4>Drag & drop or <strong>Browse</strong></h4>
                                                        <p style={{ fontSize: "12px", color: "#000000", opacity: "60%" }}>
                                                            Only PDF allowed
                                                        </p>
                                                    </div>
                                                )}
                                                {lessonErrors?.file && <Typography color="error" variant="caption">{lessonErrors?.file}</Typography>}
                                                {(uploadedFilePath || pdfUrl) && (
                                                    <>
                                                        <Box mt={2} display="flex" alignItems="center" justifyContent="space-between">
                                                            <Box display="flex" alignItems="center">
                                                                <InsertDriveFileIcon sx={{ color: "#6EBe44", mr: 1 }} />
                                                                <Typography variant="body2">{fileName}</Typography>
                                                            </Box>
                                                            <Button onClick={() => setOpen(true)} sx={{ border: "1px solid #ee8d80", color: "#ee8d80" }}>Preview</Button>
                                                            <Button onClick={() => { setPdfUrl(''); setFileName(''); setUploadedFilePath(''); setLessonFormInput(prev => ({ ...prev, file: null })); }} variant="outlined">Remove</Button>
                                                        </Box>
                                                    </>
                                                )}
                                            </Paper>
                                        )}
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                gap: 2,
                                                alignItems: "bottom",
                                                marginTop: 4
                                            }}>
                                            <Button
                                                className="gradientAdminThemeColor"
                                                onClick={handleSaveLessonFormInput}
                                                disabled={isPending}
                                            >
                                                {isPending ? <CircularProgress size={24} /> : lessonFormInput.ID ? "Update & Next" : "Save & Add Questions"}
                                            </Button>
                                        </Box>
                                    </>
                                )}
                                {showQuestionForm && (
                                    <>
                                        <Box display="flex" alignItems="center" gap={1} width="100%" justifyContent="space-between">
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <Chip label="L" color="success" size="small" sx={{ fontWeight: "bold", borderRadius: "4px" }} />
                                                <Typography sx={{ fontWeight: "bold" }}>Lesson: {selectedLessonCard.lessonTitleName}</Typography>
                                            </Box>
                                        </Box>
                                        <Box display="flex" alignItems="center" gap={1} width="100%" justifyContent="space-between">
                                            <Chip label={currentQuestionIndex + 1} sx={{ backgroundColor: "#6ebe44", color: "#ffffff", fontWeight: "bold", borderRadius: "4px" }} />
                                            <TextField
                                                fullWidth
                                                variant="standard"
                                                margin="normal"
                                                placeholder="Enter question"
                                                value={questions[currentQuestionIndex]?.question || ""}
                                                onChange={handleQuestionChange}
                                            />
                                            {/* Remove Question Button */}
                                            <IconButton
                                                onClick={() => handleRemoveQuestion(currentQuestionIndex)}
                                                sx={{ color: "red" }}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </Box>
                                        <Box mt={3} sx={{ width: "300px" }}>
                                            {questions[currentQuestionIndex]?.choices.map((choice, index) => (
                                                <Box key={index} sx={{ display: "flex", alignItems: "center", border: "1px solid #6ebe44", borderRadius: "8px", backgroundColor: "#f2f9f1", padding: "8px", marginBottom: "8px" }}>
                                                    <Typography sx={{ fontWeight: "bold", color: "#6ebe44", border: "1px solid #6ebe44", borderRadius: "50%", width: "24px", height: "24px", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "8px" }}>
                                                        {String.fromCharCode(65 + index)}
                                                    </Typography>
                                                    <TextField
                                                        variant="standard"
                                                        fullWidth
                                                        placeholder="Enter option value"
                                                        value={choice.option} 
                                                        onChange={(e) => {
                                                            setQuestions(prevQuestions => {
                                                                const updatedQuestions = [...prevQuestions];
                                                                const updatedChoices = [...updatedQuestions[currentQuestionIndex].choices]; 
                                                                updatedChoices[index] = {
                                                                    ...updatedChoices[index], 
                                                                    option: e.target.value, 
                                                                };
                                                                updatedQuestions[currentQuestionIndex] = {
                                                                    ...updatedQuestions[currentQuestionIndex], 
                                                                    choices: updatedChoices, 
                                                                };
                                                                return updatedQuestions;
                                                            });
                                                        }}
                                                        InputProps={{
                                                            disableUnderline: true,
                                                            sx: { fontStyle: "italic", color: "#6ebe44" },
                                                        }}
                                                    />
                                                    <IconButton
                                                        onClick={() => handleRemoveChoice(index)}
                                                        sx={{ color: "#6ebe44", marginLeft: "8px" }}
                                                    >
                                                        <CloseIcon />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                            <Typography
                                                onClick={handleAddChoice}
                                                sx={{ color: "#6ebe44", cursor: "pointer", fontStyle: "italic", textDecoration: "underline" }}
                                            >
                                                +Add choice
                                            </Typography>
                                            <Typography variant="h6" sx={{ mt: 2 }}>Select Correct Answer</Typography>
                                            <RadioGroup
                                                value={questions[currentQuestionIndex]?.correctAnswer || ""}
                                                onChange={(e) => {
                                                    setQuestions(prevQuestions => {
                                                        const updatedQuestions = [...prevQuestions];
                                                        updatedQuestions[currentQuestionIndex] = {
                                                            ...updatedQuestions[currentQuestionIndex], 
                                                            correctAnswer: e.target.value, 
                                                        };
                                                        return updatedQuestions;
                                                    });
                                                }}
                                            >
                                                {questions[currentQuestionIndex]?.choices.map((choice, index) => (
                                                    <FormControlLabel
                                                        key={index}
                                                        value={choice.option} 
                                                        control={<Radio />}
                                                        label={choice.option} 
                                                    />
                                                ))}
                                            </RadioGroup>
                                        </Box>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "end",
                                                gap: 2,
                                                alignItems: "bottom",
                                                marginTop: 5
                                            }}>
                                            <Typography
                                                sx={{
                                                    color: "#6ebe44",
                                                    cursor: "pointer",
                                                    fontStyle: "italic",
                                                    textDecoration: "underline",
                                                    display: "inline-block",
                                                    marginTop: "10px",
                                                }}
                                                onClick={handleSaveAndAddNew}
                                            >
                                                Save & Add Question
                                            </Typography>
                                            {currentQuestionIndex === questions.length - 1 && (
                                                <Button
                                                    className="gradientAdminThemeColor"
                                                    onClick={handleSaveLessonWithQuestions}
                                                    disabled={saveQuestionMutation.isPending}
                                                >
                                                    {saveQuestionMutation?.isPending ? <CircularProgress size={24} /> : "Save"}
                                                </Button>
                                            )}
                                        </Box>
                                        <Divider sx={{ marginTop: 3 }} />
                                        <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: 1 }}>
                                            <Button
                                                disabled={currentQuestionIndex === 0}
                                                onClick={handleQuestionBack}
                                            >
                                                Back
                                            </Button>
                                            <Typography variant="h6">
                                                Question {currentQuestionIndex + 1} of {questions.length}
                                            </Typography>
                                            <Button
                                                disabled={currentQuestionIndex === questions.length - 1}
                                                onClick={handleQuestionNext}
                                            >
                                                Next
                                            </Button>
                                        </Box>
                                    </>
                                )}
                            </Grid>
                        </Card>
                    </Grid>
                    {/* Learning Settings */}
                    <Grid item xs={12} sm={3} >
                        <form onSubmit={handleSubmit(submitAddDocument)}>
                            <Card
                                sx={{
                                    padding: "2rem", display: "flex", borderRadius: "2px", flex: 1, overflowY: "auto", flexDirection: "column",
                                    height: "80vh",
                                }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 2,
                                        mb: 3,
                                        width: "100%",
                                    }}>
                                    <Typography variant="h4" component="div" fontWeight="bold">
                                        Settings
                                    </Typography>
                                    <Divider />
                                    <TextField
                                        label="Traning Name"
                                        variant="outlined"
                                        fullWidth
                                        margin="normal"
                                        autoFocus={true}
                                        sx={{
                                            "& .MuiOutlinedInput-input": {
                                                padding: 1.94,
                                            },
                                            "& .MuiFormHelperText-root": {
                                                marginLeft: 0,
                                                marginTop: "4px",
                                            },
                                        }}
                                        {...register("trainingCertificateName")}
                                        error={!!errors.trainingCertificateName}
                                        helperText={errors.trainingCertificateName?.message}
                                    />
                                    <FormControl fullWidth >
                                        <Controller
                                            name="JOBROLE_ID"
                                            control={control}
                                            render={({ field }) => (
                                                <>
                                                    <TextField
                                                        {...field}
                                                        select
                                                        label="Assign to Job Roles"
                                                        onChange={(event) => {
                                                            field.onChange(event.target.value); 
                                                            handleRoleChange(event.target.value); 
                                                        }}
                                                        error={!!errors.JOBROLE_ID || isError}
                                                        helperText={
                                                            errors.JOBROLE_ID?.message ||
                                                            (isError ? "Failed to fetch job roles. Please try again." : "")
                                                        }
                                                        disabled={isLoading} 
                                                        InputProps={{
                                                            endAdornment: isLoading && <CircularProgress size={24} />,
                                                        }}
                                                        SelectProps={{
                                                            MenuProps: {
                                                                anchorOrigin: {
                                                                    vertical: "bottom",
                                                                    horizontal: "left",
                                                                },
                                                                transformOrigin: {
                                                                    vertical: "top",
                                                                    horizontal: "left",
                                                                },
                                                                getContentAnchorEl: null, 
                                                            },
                                                        }}
                                                    >
                                                        <MenuItem disabled value="">Select</MenuItem>
                                                        {fetchJobRole.map((role) => (
                                                            <MenuItem key={role.ID} value={role.ID}>{role.ROLE_NAME}</MenuItem>
                                                        ))}
                                                    </TextField>
                                                </>
                                            )}
                                        />
                                        <Box sx={{ mt: 2 }}>
                                            {selectedRoles.length > 0 && (
                                                <Grid container spacing={1}>
                                                    {selectedRoles.map((jobRoleID) => {
                                                        const role = fetchJobRole.find((role) => role.ID === jobRoleID);
                                                        if (!role) return null; 
                                                        return (
                                                            <Grid item xs={4} key={jobRoleID}>
                                                                <Chip
                                                                    label={role.ROLE_NAME}
                                                                    onDelete={() => handleChipDelete(jobRoleID)}
                                                                    sx={{ borderRadius: 0.9 }}
                                                                />
                                                            </Grid>
                                                        );
                                                    })}
                                                </Grid>
                                            )}
                                        </Box>
                                    </FormControl>
                                    <FormControl
                                        fullWidth
                                        sx={{ marginTop: 1 }}
                                        error={!!errors.status}>
                                        <InputLabel id="status-select-label">Status</InputLabel>
                                        <Controller
                                            name="status"
                                            control={control}
                                            render={({ field }) => (
                                                <Select
                                                    autoFocus
                                                    labelId="status-select-label"
                                                    id="status-select"
                                                    label="Status"
                                                    {...field}
                                                    error={!!errors.status}>
                                                    <MenuItem value="Active">Active</MenuItem>
                                                    <MenuItem value="Inactive">Inactive</MenuItem>
                                                </Select>
                                            )}
                                        />
                                        {errors.status && (
                                            <FormHelperText>
                                                {errors.status?.message}
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                    <FormControl fullWidth error={!!errors.requirementType}>
                                        <Controller
                                            name="requirementType"
                                            control={control}
                                            render={({ field }) => (
                                                <>
                                                    <InputLabel id="demo-simple-select-label">Requirement</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="requirement-select"
                                                        label="Training Type"
                                                        {...field}
                                                        error={!!errors.requirementType}
                                                    >
                                                        <MenuItem disabled value="">Select Requirement</MenuItem>
                                                        <MenuItem value="Optional">Optional</MenuItem>
                                                        <MenuItem value="Mandatory">Mandatory</MenuItem>
                                                    </Select></>
                                            )}
                                        />
                                        {errors.requirementType && <FormHelperText error>{errors.requirementType?.message}</FormHelperText>}
                                    </FormControl>
                                    <TextField
                                        label="How many Re-attempt"
                                        variant="outlined"
                                        fullWidth
                                        type="text"
                                        margin="normal"
                                        inputProps={{
                                            min: 1,
                                            max: 9,
                                            step: 1, 
                                        }}
                                        sx={{
                                            "& .MuiOutlinedInput-input": {
                                                padding: 1.94,
                                            },
                                            "& .MuiFormHelperText-root": {
                                                marginLeft: 0,
                                            },
                                        }}
                                        {...register("noOfReattempt")}
                                        error={!!errors.noOfReattempt}
                                        helperText={errors.noOfReattempt?.message}
                                    />
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            gap: 2,
                                            alignItems: "bottom",
                                        }}>
                                        <Button
                                            variant="outlined"
                                            sx={{ width: "90px", color: "#6ebe44" }}
                                            onClick={handleOpen}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            className="gradientAdminThemeColor"
                                            type="submit"
                                        >
                                            {saveTrainingMutation?.isPending ? <CircularProgress size={24} /> : "Final & Save"}
                                        </Button>
                                    </Box>
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 2,
                                        width: "100%",
                                    }}
                                >
                                    {trainingLessonsErrors.length > 0 && (
                                        <Grid container spacing={1} sx={{ mt: 0.5 }}>
                                            {trainingLessonsErrors.map((error, index) => (
                                                <Grid item xs={12} key={index}>
                                                    <Typography sx={{ color: "red", fontSize: "0.875rem" }}><span style={{ color: "red" }}>*</span>{error}</Typography>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    )}
                                </Box >
                            </Card>
                        </form >
                    </Grid>
                </Grid>
            </Grid >
            {open && <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
                <DialogTitle sx={{ m: 0, p: 2 }}>
                    PDF Document
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{ position: 'absolute', right: 8, top: 8, color: "#000000" }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ display: 'flex', justifyContent: 'center' }}>
                    <div style={{ width: '60%' }}>
                        <PdfViewer file={pdfUrl || uploadedFilePath} />
                    </div>
                </DialogContent>
            </Dialog>}
        </Grid >
    );
};

export default memo(LessonList);

